// video hover
!(function () {
  window.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.product-card').forEach(function (element) {
      const slideVideo = element.querySelector('video');
      const iframeWrap = element.querySelector('.iframe_wrap');
      const iframe = iframeWrap ? iframeWrap.getAttribute('data-video') : '';
      let hoverInited = false;
      element.addEventListener('mouseover', function () {
        if (slideVideo) slideVideo.play();

        if (iframeWrap) {
          if (null == iframeWrap.querySelector('iframe')) {
            iframeWrap.innerHTML = '';
            iframeWrap.insertAdjacentHTML('beforeend', iframe);
            if (iframeWrap.querySelector('iframe'))
              iframeWrap.querySelector('iframe').src = iframeWrap.querySelector('iframe').src + '&autoplay=1';
          }
        }
        hoverInited = true;
      });
      element.addEventListener('mouseout', function () {
        hoverInited = false;
        if (slideVideo) slideVideo.pause();
        if (iframeWrap) {
          setTimeout(function () {
            if (!hoverInited) {
              iframeWrap.innerHTML = '';
            }
          }, 200);
        }
      });
    });
  });

})();
// end video hover
(function ($) {
  $(document).ready(function () {
    $('.shopify-section--main-blog .section-stack .content-tags .filters-mobile').click(function () {
      $(this).toggleClass('active');
      $('.shopify-section--main-blog .blog-tags').slideToggle();
    });
    $('.page_transition_box').removeClass('active_transition_loading');
    $('.page_transition_box_text').removeClass('active_transition_loading');
  });

  $(".template-index section[data-section-type=featured-collections2]").css('opacity', '1')

  //Function Enquiry
  $(".enquiry-form-btn").on("click", function () {
    $('.enquiry_form_section').fadeIn();
    $('.enquiry_form_section').addClass('tooltip_drawer_open');
  });
  $('.enquiry_form_section').on('click', '.close_btn_wrap', function () {
    $('.enquiry_form_section').removeClass('tooltip_drawer_open');
    $('.enquiry_form_section').addClass('tooltip_drawer_close');
    setTimeout(() => {
      $('.enquiry_form_section').removeClass('tooltip_drawer_close');
    }, 500);
    $('.enquiry_form_section').fadeOut();
  });
  $('.enquiry_form_section').on('click', '.section_bg', function () {
    $('.enquiry_form_section').removeClass('tooltip_drawer_open');
    $('.enquiry_form_section').addClass('tooltip_drawer_close');
    setTimeout(() => {
      $('.enquiry_form_section').removeClass('tooltip_drawer_close');
    }, 500);
    $('.enquiry_form_section').fadeOut();
  });

  $.fn.hasAttr = function (name) {
    return this.attr(name) !== undefined;
  };

  $('summary').click(function (e) {
    if ($(this).attr('data-follow-link') != '') {
      let thisLink = $(this).attr('data-follow-link');
      if (thisLink != '' && thisLink != '#') {
        let trag = false;
        if ($(this).attr('target') == '_blank') {
          trag = true;
        }
        if ($(this).attr('Download') == 'menu') {
          trag = true;
        }
        if (thisLink != undefined) {
          if (thisLink.length && trag == false) {
            e.preventDefault();
            $('.page_transition_box').addClass('active_transition');
            $('.page_transition_box_text').addClass('active_transition');
            setTimeout(function () {
              if (thisLink.includes('https://') || thisLink.includes('http://')) {
                window.location.href = thisLink;
              } else {
                let originAdress = window.location.origin;
                let newAdress = originAdress + thisLink;
                window.location.href = newAdress.replace(/\s/g, '');
                // $('.page_transition_box').removeClass('active_transition');
                // $('.page_transition_box_text').removeClass('active_transition');
              }
            }, 1000);
            setTimeout(function () {
              $('.page_transition_box').removeClass('active_transition');
              $('.page_transition_box_text').removeClass('active_transition');
            }, 3000)
          }
        }
      }
    }
  });

  $('a:not([data-action="open-drawer"]):not([href*="tooltip_drawer"]):not([href*="tooltip_drawer_shipping"]):not([href*="tooltip_drawer_coffee_roasting"]):not([href="/search"]):not([href*="#modalFormWholesale"])').click(function (e) {
    if (!$(this).hasClass('build-subcription') && !$(this).hasClass('cart-drawer-menu') && !$(this).hasClass('location-button')) {
      let thisLink = $(this).attr('href');
      let trag = false;
      if ($(this).attr('target') == '_blank') {
        trag = true;
      }
      if ($(this).attr('Download') == 'menu') {
        trag = true;
      }
      if (thisLink != undefined) {
        if (thisLink.length && trag == false) {
          e.preventDefault();
          $('.page_transition_box').addClass('active_transition');
          $('.page_transition_box_text').addClass('active_transition');
          setTimeout(function () {
            if (thisLink.includes('https://') || thisLink.includes('http://')) {
              window.location.href = thisLink;
            } else {
              let originAdress = window.location.origin;
              let newAdress = originAdress + thisLink;
              window.location.href = newAdress.replace(/\s/g, '');
            }
          }, 1000);
          setTimeout(function () {
            $('.page_transition_box').removeClass('active_transition');
            $('.page_transition_box_text').removeClass('active_transition');
          }, 3000)
        }
      }
    }
  });
})(jQuery);